/* eslint-disable react-refresh/only-export-components */
import React, { createContext, useContext, useState, useEffect, ReactNode } from "react";
import { useHotelSettingsService } from "../hooks/useAdminServices";
import { logger } from "../utils/logger";

const HotelTimezoneContext = createContext<string>("UTC");

export const useHotelTimezone = (): string => useContext(HotelTimezoneContext);

interface HotelTimezoneProviderProps {
  children: ReactNode;
  initialTimeZone?: string;
}

export const HotelTimezoneProvider: React.FC<HotelTimezoneProviderProps> = ({ children, initialTimeZone }) => {
  const [timeZone, setTimeZone] = useState<string>(initialTimeZone || "UTC");
  const settingsService = useHotelSettingsService();

  // Skip fetch if initial data was provided by bootstrap
  useEffect(() => {
    if (initialTimeZone !== undefined || !settingsService) return;

    const fetchTimezone = async (): Promise<void> => {
      const result = await settingsService.getSettings();
      if (result.success && result.data?.timeZone) {
        setTimeZone(result.data.timeZone);
      } else {
        logger.warn("Failed to fetch hotel timezone, defaulting to UTC");
      }
    };

    fetchTimezone();
  }, [settingsService, initialTimeZone]);

  return (
    <HotelTimezoneContext.Provider value={timeZone}>
      {children}
    </HotelTimezoneContext.Provider>
  );
};
